import { Box } from 'grommet'
import * as React from 'react'
import { SectionTextStyle, SectionTitleStyle } from './style'

export interface IOverviewHeadingProps {}

export default class OverviewHeading extends React.PureComponent<IOverviewHeadingProps> {
  public render() {
    return (
      <Box>
        <SectionTitleStyle>Visão geral</SectionTitleStyle>
        <SectionTextStyle>Análise os dados de acordo com o mês e a loja selecionada.</SectionTextStyle>
      </Box>
    )
  }
}
